import { BASE_URL } from "../api_const";

export const URL_GET_ENQUIRY_HISTORY = BASE_URL + "/admin/project/enquiry"